export const differentialAmperageCategories = ['rcbo', 'afdd', 'rccb'];
export const differentialClassCategories = ['rcbo', 'afdd', 'rccb'];
export const differentialTripCurveCategories = ['mcb', 'rcbo', 'afdd'];
